export default "__VITE_ASSET__9ea60c97__"